import { render, staticRenderFns } from "./ssp.vue?vue&type=template&id=70ed6d56"
import script from "./ssp.vue?vue&type=script&lang=js"
export * from "./ssp.vue?vue&type=script&lang=js"
import style0 from "./index.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./style.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports